export default "__VITE_ASSET__Cnf7ZDvr__"